import { Route, Switch, useRouteMatch } from "react-router-dom";

import Layout from "@/containers/Layout";
import MentionCardsProvider from "@/containers/MentionCardsProvider";
import { FEATURE } from "@/features";
import { useHasFeature } from "@/hooks/useHasFeature";
import { RELATIVE_PATHS, ROUTES } from "@/routes_new";
import Unavailable from "@/views/archive/unavailable";
import MentionsInsightsView from "@/views/MentionsView/Insights";
import MentionLayout from "@/views/MentionsView/MentionLayout";

import AnchorRedirect from "../AnchorRedirect";
import MentionSettingsView from "../MentionSettingsView";
import MentionsListView from "./List/index_v4";

export const MentionsViewInner = ({ url = ROUTES.MENTION_DETAIL_ORGID }) => {
  const hasPermission = useHasFeature(
    FEATURE.HAS_READ_EXPIRED_SEARCHES_MENTIONS_FEATURE
  );
  const isArchivePage = !!useRouteMatch(ROUTES.ARCHIVE_DETAIL_ORGID);
  const shouldRenderUnavailablePage = !hasPermission && isArchivePage;

  return (
    <MentionCardsProvider>
      <Switch>
        <Route path={url}>
          <Switch>
            <Route
              exact
              path={`${url}${RELATIVE_PATHS.ALERT_SETTINGS}/`}
              component={MentionSettingsView}
            />
            <Route>
              {shouldRenderUnavailablePage ? (
                <Unavailable />
              ) : (
                <MentionLayout url={url}>
                  <Switch>
                    <Route
                      exact
                      component={MentionsInsightsView}
                      path={`${url}${RELATIVE_PATHS.ALERT_INSIGHTS}/`}
                    />
                    <Route component={MentionsListView} path={url} exact />
                    <Route
                      path={ROUTES.MENTIONS_ANCHOR_ORGID}
                      component={AnchorRedirect}
                    />
                  </Switch>
                </MentionLayout>
              )}
            </Route>
          </Switch>
        </Route>
      </Switch>
    </MentionCardsProvider>
  );
};

const MentionsView = (props: { url?: string }) => (
  <Layout>
    <MentionsViewInner {...props} />
  </Layout>
);

export default MentionsView;
